module.exports = __webpack_public_path__ + "img/bg-car-light.cf961c7d.png";